import { useFormikContext } from 'formik';
import { DatePicker, DatePickerSelect, Icon } from 'Components';
import Layout from './Layout';
import { EditProfileValues, EditUserValues } from 'Pages/User/User.types';
import { useTranslation } from 'react-i18next';
import ToggleButton from 'Components/ToggleButton';
import Label from './Label';
import Alert from 'PhishingManager/components/Alert';

const Notification = ({ openModal }: { openModal: () => void }) => {
	const { t } = useTranslation();
	const notificationForm = useFormikContext<EditProfileValues>();
	const { isValid, dirty, values } = notificationForm;
	const btnDisable = !(isValid && dirty);
	const disabled = !values.timezoneId;
	const { getWeeklyReport, getDeletionReport } =
		notificationForm.values.notifications || {};
	const baseTextPath = 'profile.notifications';

	return (
		<>
			{disabled && (
				<Alert
					iconType="phishingManagerWarningModal"
					title={t(`${baseTextPath}.emailAlert.title`)}
					subtitle={t(`${baseTextPath}.emailAlert.description`)}
				/>
			)}
			<Layout
				title={t(`${baseTextPath}.title`)}
				description={t(`${baseTextPath}.description`)}
				btnText={t(`saveChanges`)}
				handleNext={openModal}
				btnDisable={btnDisable}
			>
				<DatePickerSelect.FormikField
					label={
						<Label
							labelText={t(`${baseTextPath}.fields.weekday`)}
						/>
					}
					name="notifications.day"
					picker="weekday"
					listHeight={200}
					disabled={disabled}
				/>
				<DatePicker.FormikField
					label={
						<Label labelText={t(`${baseTextPath}.fields.time`)} />
					}
					name="notifications.time"
					picker="time"
					dropdownClassName="time-picker-dropdown"
					minuteStep={15}
					disabled={disabled}
					allowClear={false}
				/>

				<ToggleButton
					disabled={disabled}
					prefixText={baseTextPath}
					labelText={
						<Label
							labelText={t(
								`${baseTextPath}.fields.getWeeklyReport`
							)}
							tooltipText={t(
								`${baseTextPath}.generalMailsTooltip`
							)}
						/>
					}
					checked={!!getWeeklyReport}
					setChecked={(value) =>
						notificationForm.setFieldValue(
							'notifications.getWeeklyReport',
							value
						)
					}
				/>

				<ToggleButton
					disabled={disabled}
					prefixText={baseTextPath}
					labelText={
						<Label
							labelText={t(
								`${baseTextPath}.fields.getDeletionReport`
							)}
							tooltipText={t(
								`${baseTextPath}.manageUsersAndGroupsTooltip`
							)}
						/>
					}
					checked={!!getDeletionReport}
					setChecked={(value) =>
						notificationForm.setFieldValue(
							'notifications.getDeletionReport',
							value
						)
					}
				/>
			</Layout>
		</>
	);
};

export default Notification;
